import { all, takeLeading, takeLatest, put, call, select, takeEvery } from 'redux-saga/effects'
import { notification } from 'antd'
import { history } from 'index'

import { getConfig } from 'env'
import { getSearchParams } from 'utils'

// import { getUMKFromLocal } from 'pUtils'

import store from 'store'

// import * as firebase from 'services/firebase'
import * as jwt from 'services/jwt'
import * as landing from 'services/landing'
import actions from './actions'

const mapAuthProviders = {
  // firebase: {
  //   login: firebase.login,
  //   register: firebase.register,
  //   currentAccount: firebase.currentAccount,
  //   logout: firebase.logout,
  // },
  jwt: {
    login: jwt.login,
    loginByOTP: jwt.loginByOTP,
    loginByKey: jwt.loginByKey,
    register: jwt.register,
    currentAccount: jwt.currentAccount,
    logout: jwt.logout,
  },
  landing: {
    login: landing.login,
    loginByOTP: landing.loginByOTP,
    loginByKey: landing.loginByKey,
    loginByToken: landing.loginByToken,
    register: landing.register,
    umkLogin: landing.umkLogin,
    umkRegister: landing.umkRegister,
    umkChangePW: landing.umkChangePW,
    currentAccount: landing.currentAccount,
    logout: landing.logout,
  },
}

export function* LOGIN_BY_OTP({ payload }) {
  const { email, loginCode } = payload
  // yield console.log(email, loginCode)

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select((state) => state.settings)
  const success = yield call(mapAuthProviders[autProviderName].loginByOTP, email, loginCode)
  if (success) {
    yield INNER_LOAD_CURRENT_ACCOUNT(true)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })

  if (!success) {
    yield history.push('/auth/login')
  }
}

export function* LOGIN({ payload }) {
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select((state) => state.settings)
  const success = yield call(mapAuthProviders[autProviderName].login, email, password)
  if (success) {
    yield INNER_LOAD_CURRENT_ACCOUNT(true)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })

  if (!success) {
    // notification.warning({
    //   message: 'Login error',
    //   description: 'LoginByKey failed.',
    // })
    yield history.push('/auth/login')
  }
}

export function* LOGIN_BY_KEY({ payload }) {
  const { key } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select((state) => state.settings)
  const result = yield call(mapAuthProviders[autProviderName].loginByKey, key)
  if (result === 'success') {
    yield INNER_LOAD_CURRENT_ACCOUNT(true)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })

  if (result !== 'success') {
    // notification.warning({
    //   message: 'Login error',
    //   description: 'LoginByKey failed.',
    // })
    yield history.push('/auth/login')
  }
}

export function* OAUTHLOGIN({ payload }) {
  // yield put({
  //   type: 'user/LOAD_CURRENT_ACCOUNT',
  // })
  // yield history.replace('/plain/waiting')
  yield put({
    type: 'user/LOAD_CURRENT_ACCOUNT',
  })

  const provisioning = yield store.get('app.user.provisioning')

  if (provisioning !== true) {
    const defaultPage = getConfig('defaultPage') || '/'
    const target = payload && payload.target ? payload.target : defaultPage
    history.push(target)
  }
  // notification.success({
  //   message: 'Logged In',
  //   description: 'You have successfully logged in!',
  // })
}

export function* LOGIN_BY_TOKEN({ payload }) {
  const { tokenInfo } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select((state) => state.settings)
  const result = yield call(mapAuthProviders[autProviderName].loginByToken, tokenInfo)
  if (result === 'success') {
    yield INNER_LOAD_CURRENT_ACCOUNT(true)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })

  if (result !== 'success') {
    yield history.push('/auth/login')
  }
}

export function* REGISTER({ payload }) {
  const { email, password, name } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider } = yield select((state) => state.settings)
  const success = yield call(mapAuthProviders[authProvider].register, email, password, name)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })

    yield history.push('/')

    notification.success({
      message: 'Succesful Registered',
      description: 'You have successfully registered!',
    })
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* UMK_LOGIN({ payload }) {
  const { password, path } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      umkProcessing: true,
    },
  })
  const { authProvider } = yield select((state) => state.settings)
  const success = yield call(mapAuthProviders[authProvider].umkLogin, password)

  if (success) {
    let nextPath = path
    if (nextPath == null || nextPath.indexOf('/masterPW/') === 0) {
      nextPath = getConfig('defaultPage') || '/'
    }
    yield history.push(nextPath)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      umkProcessing: false,
    },
  })
}

export function* UMK_REGISTER({ payload }) {
  const { password, path } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      umkProcessing: true,
    },
  })

  const { authProvider } = yield select((state) => state.settings)
  const success = yield call(mapAuthProviders[authProvider].umkRegister, password)

  if (success) {
    let nextPath = path
    if (nextPath == null || nextPath.indexOf('/masterPW/') === 0) {
      nextPath = getConfig('defaultPage') || '/'
    }
    yield history.push(nextPath)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      umkProcessing: false,
    },
  })
}

export function* UMK_CHANGEPW({ payload }) {
  const { password, newPassword, path } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      umkProcessing: true,
    },
  })

  const { authProvider } = yield select((state) => state.settings)
  const success = yield call(mapAuthProviders[authProvider].umkChangePW, password, newPassword)

  if (success) {
    let nextPath = path
    if (nextPath == null || nextPath.indexOf('/masterPW/') === 0) {
      nextPath = getConfig('defaultPage') || '/'
    }
    yield history.push(nextPath)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      umkProcessing: false,
    },
  })
}

function* INNER_LOAD_CURRENT_ACCOUNT(useByLogin) {
  try {
    const { authProvider } = yield select((state) => state.settings)
    const response = yield call(mapAuthProviders[authProvider].currentAccount)
    if (response) {
      const { id, email, name, avatar, role, serverType, workspace, provisioning } = response
      yield put({
        type: 'user/SET_STATE',
        payload: {
          id,
          name,
          email,
          avatar,
          role,
          authorized: true,
          serverType,
          workspace,
          provisioning,
        },
      })

      let curPath = window.location.pathname + window.location.search
      if (useByLogin || curPath.indexOf('/masterPW/register') === 0) {
        const params = getSearchParams()
        const defaultPage = getConfig('defaultPage') || '/'
        curPath = params.path != null ? window.decodeURIComponent(params.path) : defaultPage
      }

      // const success = false
      // switch (authType) {
      //   case 'login':
      //     {
      //       // masterPW login
      //       const umk = yield call(getUMKFromLocal, true)
      //       if (umk != null) {
      //         success = yield call(mapAuthProviders[authProvider].umkLogin, umk)
      //       }
      //       // success == null 인 경우는 알수 없는 오류이므로 현상태 유지.
      //       if (success === false) {
      //         if (curPath.indexOf('/migration') === 0) {
      //           yield history.push('/migration')
      //         } else {
      //           yield history.push(`/migration?path=${curPath}`)
      //         }
      //       }
      //     }
      //     break
      //   case 'register': // masterPW register
      //     if (curPath.indexOf('/masterPW/register') === 0) {
      //       yield history.push('/masterPW/register')
      //     } else {
      //       yield history.push(`/masterPW/register?path=${curPath}`)
      //     }
      //     break
      //   case 'change-password': // masterPW change-password
      //     if (curPath.indexOf('/masterPW/changePW') === 0) {
      //       yield history.push('/masterPW/changePW')
      //     } else {
      //       yield history.push(`/masterPW/changePW?path=${curPath}`)
      //     }
      //     break
      //   default:
      // }

      // if (success === true) {
      yield history.push(curPath)
      // }
    }
  } catch (error) {
    console.log(error)

    yield put({
      type: 'user/SET_STATE',
      payload: {
        authorized: false,
      },
    })

    // 인증오류 또는 토큰이 없거나 만료된 경우를 제외하면 로그아웃 처리하지 않음.
    // yield put({
    //   type: 'user/LOGOUT',
    // })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  yield INNER_LOAD_CURRENT_ACCOUNT(false)

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  const { authProvider } = yield select((state) => state.settings)
  yield call(mapAuthProviders[authProvider].logout)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
    },
  })
  // yield history.push('/');
}

export default function* rootSaga() {
  yield all([
    takeLeading(actions.LOGIN_BY_OTP, LOGIN_BY_OTP),
    takeLeading(actions.LOGIN, LOGIN),
    takeLeading(actions.LOGIN_BY_KEY, LOGIN_BY_KEY),
    takeLeading(actions.OAUTHLOGIN, OAUTHLOGIN),
    takeLeading(actions.LOGIN_BY_TOKEN, LOGIN_BY_TOKEN),
    takeLeading(actions.REGISTER, REGISTER),
    takeLatest(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeLeading(actions.LOGOUT, LOGOUT),
    takeEvery(actions.UMK_LOGIN, UMK_LOGIN),
    takeLeading(actions.UMK_REGISTER, UMK_REGISTER),
    takeLeading(actions.UMK_CHANGEPW, UMK_CHANGEPW),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
